import {Trans} from '@common/i18n/trans';
import {FormTextField} from '@common/ui/forms/input-field/text-field/text-field';

const documentFields = [
  {name: "physical_detail_1", title: "HEALTH DOCUMENTS", label: "Add notes about health documents here"},
  {name: "physical_detail_2", title: "PROPERTY DOCUMENTS", label: "Add notes about property documents here"},
  {name: "physical_detail_3", title: "LEGAL DOCUMENTS", label: "Add notes about legal documents here"},
  {name: "physical_detail_4", title: "VEHICLE DOCUMENTS", label: "Add notes about vehicle documents here"},
  {name: "physical_detail_5", title: "BUSINESS DOCUMENTS", label: "Add notes about business documents here"},
  {name: "physical_detail_6", title: "FINANCE DOCUMENTS", label: "Add notes about finance documents here"},
  {name: "physical_detail_7", title: "TAXATION DOCUMENTS", label: "Add notes about taxation documents here"},
  {name: "physical_detail_8", title: "SAFE AND DEPOSIT BOXES", label: "Add notes about safe and deposit boxes here"},
  {name: "physical_detail_9", title: "WILL", label: "Add notes about will here"},
];

export function PhysicalDocumentsForm() {
  return (
    <>
      <h1 className="text-3xl mt-20 mb-20">
        <Trans message="LOCATION OF PHYSICAL DOCUMENTS"/>
      </h1>
      {documentFields.map(({name, title, label}) => (
        <div key={name}>
          <div className="mb-10 text-base text-muted">
            <strong><Trans message={title}/></strong>
          </div>
          <FormTextField className="mb-24" name={name} label={<Trans message={label}/>}/>
        </div>
      ))}
    </>
  );
}